import {Component} from '@angular/core';

@Component({
    selector: 'app-no-jobs',
    templateUrl: './no-jobs.component.html',
    styleUrls: ['./no-jobs.component.scss'],
    standalone: false
})
export class NoJobsComponent {

    constructor() {
    }

}
